import React, { Fragment } from 'react';
import { Trans } from '@lingui/macro';

import { Box, Button, Flex } from '@rover/kibble/core';

import CheckBoxCategory, { Category } from './CheckBoxCategory';

export type Props = {
  filtersCount?: number;
  categories: Category[];
  resetAllLinkText: string;
  resetAll: () => void;
  isChecked: (attribute: string, value: string | null | undefined) => boolean;
  onChange: (updatedFilters: Record<string, any>, checkboxValue: any | null | undefined) => void;
  onCategoryExpandAndCollapse?: () => void;
  showHeader?: boolean;
};

const CollapsingCheckBoxCollection = ({
  filtersCount,
  isChecked,
  onChange,
  categories,
  resetAll,
  resetAllLinkText,
  onCategoryExpandAndCollapse,
  showHeader = true,
}: Props): JSX.Element => {
  return (
    <Fragment>
      {showHeader && (
        <Flex justifyContent="space-between">
          {typeof filtersCount !== 'undefined' && (
            <Box paddingY="2x" paddingX="0x">
              <Trans>Filters ({filtersCount})</Trans>
            </Box>
          )}
          <Button variant="flat" size="small" onClick={resetAll}>
            {resetAllLinkText}
          </Button>
        </Flex>
      )}
      {categories.map((category) => (
        <CheckBoxCategory
          key={category.category}
          isChecked={isChecked}
          onChange={onChange}
          onExpandAndCollapse={onCategoryExpandAndCollapse}
          category={category}
        />
      ))}
    </Fragment>
  );
};

export default CollapsingCheckBoxCollection;
